import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
  TypographyProps,
} from "@mui/material";
import React, { FC, PropsWithChildren } from "react";

export const HeaderTypography: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Grid item>
      <Typography
        variant="subtitle1"
        sx={{ pt: 0.5, pb: 0.5, fontWeight: "bold" }}
      >
        {children}
      </Typography>
    </Grid>
  );
};

export const BodyTypography: FC<
  PropsWithChildren & { typographyProps?: TypographyProps }
> = ({ children, typographyProps = {} }) => {
  return (
    <Grid item>
      <Typography
        variant="body1"
        sx={{ textAlign: "justify", ...typographyProps?.sx }}
        {...typographyProps}
      >
        {children}
      </Typography>
    </Grid>
  );
};

export const BulletedList: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Grid item sx={{ ml: 4 }}>
      <List sx={{ listStyleType: "disc", width: "80%" }}>{children}</List>
    </Grid>
  );
};

export const OrderedList: FC<
  PropsWithChildren & { alphabetical?: boolean }
> = ({ alphabetical, children }) => {
  return (
    <List
      sx={{ pl: 4, listStyle: alphabetical ? "a" : "decimal" }}
      component={"ol"}
    >
      {children}
    </List>
  );
};

export const OrderedListItem: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ListItem sx={{ display: "list-item" }}>
      <ListItemText sx={{ textAlign: "justify" }}>{children}</ListItemText>
    </ListItem>
  );
};

export const BulletPoint: FC<PropsWithChildren> = ({ children }) => {
  return <ListItemText sx={{ display: "list-item" }}>{children}</ListItemText>;
};
